import { render } from "./SchoolHome.vue?vue&type=template&id=bf67bc16&scoped=true"
import script from "./SchoolHome.vue?vue&type=script&lang=js"
export * from "./SchoolHome.vue?vue&type=script&lang=js"

import "./SchoolHome.vue?vue&type=style&index=0&id=bf67bc16&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf67bc16"]])

export default __exports__